import { Component, computed, input } from "@angular/core";
import { ThousandizePipe } from "ev-core";

@Component({
    selector: "subscription-filter-keyvalue",
    templateUrl: "./subscription-filter-keyvalue.component.html",
    styleUrl: "./subscription-filter-keyvalue.component.scss",
})
export class SubscriptionFilterKeyvalueComponent {
    text = input<string>();
    valueFrom = input<string>();
    valueTo = input<string>();
    annotation? = input<string>();
    thousandize = input<boolean>();

    thousandizePipe = new ThousandizePipe();

    protected readonly fromString = computed(() => {
        const value = this.valueFrom();
        if (value == null) return "";
        const annotation = this.annotation() ?? "";
        const result = this.thousandize() ? this.thousandizePipe.transform(value) : value;
        return result.toString() + annotation;
    });

    protected readonly toString = computed(() => {
        const value = this.valueTo();
        if (value == null) return "";
        const annotation = this.annotation() ?? "";
        const result = this.thousandize() ? this.thousandizePipe.transform(value) : value;
        return result.toString() + annotation;
    });
}
